/* Class-name joiner for Tailwind-styled components.
 *
 * Convention: variant maps must hold FULL literal class strings —
 * Tailwind's content scanner cannot see interpolated names.
 *   ok:      const tones = { danger: 'bg-danger-tint text-danger' }
 *   broken:  `bg-${tone}-tint`
 */
export type ClassValue = string | false | null | undefined

export function cn(...values: ClassValue[]): string {
  return values.filter(Boolean).join(' ')
}
